export default "__VITE_ASSET__41324ddd__"